import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from '../util/date.util';

@Pipe({
  name: 'dateShort'
})
export class DateShortPipe implements PipeTransform {

  transform(value: number) {
    if (value != null && value > 0) {
      let date = new Date(value);
      return date.getDate() + " " + DateUtil.getMonthString("" + (date.getMonth() + 1));
    } else {
      return "0";
    }
  }

}
